import {
  getRoles as getRolesService,
  createRole as createRoleService,
} from "services/admin/roleManagement/role/roleService";
import {
  getRolesStart,
  getRolesSuccess,
  getRolesFailure,
  createRoleStart,
  createRoleSuccess,
  createRoleFailure,
  updateRoleStart,
  updateRoleSuccess,
  updateRoleFailure,
  deleteRoleStart,
  deleteRoleSuccess,
  deleteRoleFailure,
} from "./roleSlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch all roles
export const fetchRoles = () => async (dispatch) => {
  try {
    dispatch(getRolesStart());
    const response = await getRolesService();

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getRolesSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch roles";
      dispatch(getRolesFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch roles error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch roles";
    dispatch(getRolesFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Create a new role
export const createNewRole = (roleData) => async (dispatch) => {
  try {
    dispatch(createRoleStart());
    const response = await createRoleService(roleData);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(createRoleSuccess(response.data));
      showSuccessToast(response?.meta?.message || "Role created successfully!");
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to create role";
      dispatch(createRoleFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Create role error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to create role";
    dispatch(createRoleFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Update a role (if you have update service)
export const updateExistingRole = (roleId, roleData) => async (dispatch) => {
  try {
    dispatch(updateRoleStart());
    // Note: You'll need to add updateRoleService if you have an update API
    // const response = await updateRoleService(roleId, roleData);

    // Mock response for now - replace with actual service call
    const response = {
      meta: { status: true, message: "Role updated successfully", code: 200 },
      data: { id: roleId, ...roleData },
    };

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(updateRoleSuccess(response.data));
      showSuccessToast(response?.meta?.message || "Role updated successfully!");
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to update role";
      dispatch(updateRoleFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Update role error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to update role";
    dispatch(updateRoleFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Delete a role (if you have delete service)
export const deleteExistingRole = (roleId) => async (dispatch) => {
  try {
    dispatch(deleteRoleStart());
    // Note: You'll need to add deleteRoleService if you have a delete API
    // const response = await deleteRoleService(roleId);

    // Mock response for now - replace with actual service call
    const response = {
      meta: { status: true, message: "Role deleted successfully", code: 200 },
    };

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(deleteRoleSuccess(roleId));
      showSuccessToast(response?.meta?.message || "Role deleted successfully!");
      return { success: true, data: roleId };
    } else {
      const errorMsg = response?.meta?.message || "Failed to delete role";
      dispatch(deleteRoleFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Delete role error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to delete role";
    dispatch(deleteRoleFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};
